import { createSelector } from 'reselect';
import { MgState, SubmissionGroupEntityInterface, SubmissionGroupState } from '@types';
import { hasFeaturePermissionsSelectorFactory } from '@selectors/user';
import { FeaturePermission, PagePermission, PermissionActions } from '@enums';

const getSubmissionGroups = (store: MgState): SubmissionGroupState => store?.submissionGroup;

export const getSubmissionGroupListSelector = createSelector(
  [getSubmissionGroups],
  (groups): SubmissionGroupEntityInterface[] => groups.submissionGroups
);
export const getSubmissionGroupIsCreating = createSelector(
  [getSubmissionGroups],
  (groups: SubmissionGroupState): boolean => groups.isCreating
);
export const getSubmissionGroupIsUpdating = createSelector(
  [getSubmissionGroups],
  (groups: SubmissionGroupState): boolean => groups.isUpdating
);
export const getSubmissionGroupIsDeleting = createSelector(
  [getSubmissionGroups],
  (groups: SubmissionGroupState): boolean => groups.isDeleting
);

export const canCreateSubmissionGroupSelector = createSelector(
  [
    hasFeaturePermissionsSelectorFactory(
      PagePermission.Letters,
      [FeaturePermission.GroupList],
      [PermissionActions.Create]
    ),
  ],
  (canCreateGroup) => canCreateGroup
);

export const canRemoveSubmissionGroupSelector = createSelector(
  [
    hasFeaturePermissionsSelectorFactory(
      PagePermission.Letters,
      [FeaturePermission.GroupList],
      [PermissionActions.Remove]
    ),
  ],
  (canRemoveGroup) => canRemoveGroup
);

export const canUpdateSubmissionGroupSelector = createSelector(
  [
    hasFeaturePermissionsSelectorFactory(
      PagePermission.Letters,
      [FeaturePermission.GroupList],
      [PermissionActions.Update]
    ),
  ],
  (canRemoveGroup) => canRemoveGroup
);

export const canHaveGroupEditSelector = createSelector(
  [
    canCreateSubmissionGroupSelector,
    canUpdateSubmissionGroupSelector,
    canRemoveSubmissionGroupSelector,
  ],
  (canCreate, canUpdate, canRemove) => canCreate || canUpdate || canRemove
);

export const getAllSubmissionGroupListSelector = createSelector(
  [getSubmissionGroups],
  (groups): SubmissionGroupEntityInterface[] => groups.submissionGroupsAll
);
